<template>
  <div>
    <!-- :event-dialog-config="dialogConfig" -->
    <vue-scheduler
      eventDisplay="eventDisplay"
      @month-changed="monthChanged"
      @week-changed="weekChanged"
      @day-changed="dayChanged"
      @view-changed="viewChanged"
      @day-clicked="dayClicked"
      @time-clicked="timeClicked"
      @event-clicked="eventClicked"
      @event-created="eventCreated"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogConfig: {
        title: "Custom dialog title",
        createButtonLabel: "Save event thingy",
        enableTimeInputs: false,
        fields: [
          {
            name: "name",
            label: "Event name"
          },
          {
            name: "email",
            type: "email",
            required: true,
            label: "E-mail",
            value: "email@example.com"
          },
          {
            label: "Grouped",
            fields: [
              {
                name: "Field 1"
              },
              {
                name: "Field 2"
              }
            ]
          },
          {
            name: "comments",
            type: "textarea",
            label: "comments"
          }
        ]
      }
    };
  },
  methods: {
    eventDisplay: event => event.customAttribute,
    monthChanged(newDate) {
      console.log("Month Changed");
      console.log(newDate);
    },
    weekChanged(newDate) {
      console.log("Week Changed");
      console.log(newDate);
    },
    dayChanged(newDate) {
      console.log("Day Changed");
      console.log(newDate);
    },
    viewChanged(newView) {
      console.log("View Changed");
      console.log(newView);
    },
    dayClicked(date) {
      console.log("Day clicked");
      console.log(date.getDate());
    },
    timeClicked(dateWithTime) {
      console.log("Time clicked");
      console.log("Date: " + dateWithTime.date);
      console.log("Time: " + dateWithTime.time);
    },
    eventClicked(event) {
      console.log("Event clicked");
      console.log(event);
    },
    eventCreated(event) {
      console.log("Event created");
      console.log(event);
    }
  }
};
</script>
